import { Col, Row } from "antd";
import { useState } from "react";
import { useMutation } from "react-query";
import { getmodifiersApi } from "../../../api/modifier";
import ModifierList from "./modifierList";
import { AddEditModifier } from "./AddEditModifier";
import AddButton from "../../UI/AddButton/addbutton";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";
import { FilterInput } from "../../UI/FilterApi/filterapi";

const Modifier = () => {
  const [openModifier, setOpenModifier] = useState(false);
  const [search, setSearch] = useState<string>("");
  const [filter, setFilter] = useState<boolean | undefined>(undefined);
  const [paginatedModifier, setPaginatedModifier] = useState<any>();
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getModifier({
      limit: page * 8 + 8,
      q: "",
    }).then((res) => {
      setPaginatedModifier(res.data?.data);
      setSearch("");
      setFilter(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const handleSearch = () => {
    getModifier({
      limit: page * 8 + 8,
      q: search,
      isActive: filter,
    }).then((res: any) => {
      setPaginatedModifier(res.data?.data);
    });
  };

  const handleFilter = (value: boolean | undefined) => {
    setFilter(value);
    const isActive = value === undefined ? undefined : value;
    getModifier({
      limit: page * 8 + 8,
      q: "",
      isActive: isActive,
    }).then((res: any) => {
      setPaginatedModifier(res.data?.data);
    });
  };

  const getModifier = async (params: {
    limit: number;
    q: string;
    isActive?: boolean;
  }) => {
    // Make your API request here using the updated parameters
    return await ModifierMutation(params);
  };

  const { mutateAsync: ModifierMutation, isLoading: isModifierLoading } =
    useMutation("modifiers", getmodifiersApi);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={4}>
          <Search
            value={search}
            onKeyPress={(e: any) => e.code === "Enter" && handleSearch()}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Col>
        <Col span={2}>
          <FilterInput
            key={tableKey}
            onChange={(value: boolean | undefined) => handleFilter(value)}
            value={filter}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
              }}
            />
          </Col>
          <AddButton onClick={() => setOpenModifier(true)} />
        </Col>
        <Col span={24}>
          <ModifierList
            paginatedModifier={paginatedModifier}
            isModifierLoading={isModifierLoading}
            setPaginatedModifier={setPaginatedModifier}
            ModifierMutation={ModifierMutation}
            page={page}
            setPage={setPage}
            filter={filter}
            search={search}
            tableKey={tableKey}
          />
        </Col>
      </Row>
      {openModifier && (
        <AddEditModifier
          openModifier={openModifier}
          setOpenModifier={setOpenModifier}
          setPaginatedModifier={setPaginatedModifier}
          ModifierMutation={ModifierMutation}
          page={page}
          filter={filter}
          search={search}
        />
      )}
    </>
  );
};

export default Modifier;
